import CogIcon from "@/assets/icons/feature-details/cog-tooth.svg?react";
import MapPinIcon from "@/assets/icons/feature-details/map-pin.svg?react";
import MapIcon from "@/assets/icons/feature-details/map.svg?react";
import SignalIcon from "@/assets/icons/feature-details/signal.svg?react";
import ShareIcon from "@/assets/icons/feature-details/share.svg?react";
import KeyIcon from "@/assets/icons/feature-details/key.svg?react";

export const options = [
  {
    label: "Fleet management",
    icon: CogIcon
  },
  {
    label: "Geofencing",
    icon: MapPinIcon
  },
  {
    label: "Real-time location",
    icon: MapIcon
  },
  {
    label: "Remote vehicle control",
    icon: SignalIcon
  },
  {
    label: "Shared link",
    icon: ShareIcon
  },
  {
    label: "User access control",
    icon: KeyIcon
  },
]